
(() => {
  document.addEventListener('click', (e) => {
    const arr = e.target.closest?.('[data-footer-sub]');
    if (!arr) return;

    const item = arr.closest('.site-footer__item, .sa-foot__item');
    if (!item) return;
    const cls = item.classList.contains('sa-foot__item') ? 'is-open' : 'site-footer__item--open';
    const open = item.classList.toggle(cls);
    arr.setAttribute('aria-expanded', String(open));
  });
})();
